import styled from 'styled-components'

export type TimelineNodeTone = 'neutral' | 'info' | 'collection' | 'dashed' | 'failed' | 'scheduled'

export const Timeline = styled.div`
  display: flex;
  flex-direction: column;
`

export const TimelineRow = styled.div`
  display: flex;
  gap: ${({ theme }) => theme.spacing.md}rem;
`

export const TimelineRail = styled.div<{ $compact?: boolean }>`
  flex: 0 0 ${({ $compact }) => ($compact ? '24px' : '40px')};
  display: flex;
  flex-direction: column;
  align-items: center;
`

export const TimelineNode = styled.span<{ $tone: TimelineNodeTone; $compact?: boolean }>`
  width: ${({ $compact }) => ($compact ? '24px' : '28px')};
  height: ${({ $compact }) => ($compact ? '24px' : '28px')};
  flex: 0 0 ${({ $compact }) => ($compact ? '24px' : '28px')};
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: ${({ theme }) => theme.fontSize.xs}rem;
  font-weight: 700;

  ${({ theme, $tone }) => {
    switch ($tone) {
      case 'info':
        return `
          background: ${theme.dashboard.infoTint};
          color: ${theme.dashboard.infoDeep};
        `
      case 'collection':
        return `
          background: ${theme.dashboard.cautionTint};
          color: ${theme.colors.kraviaOrange};
        `
      case 'dashed':
      case 'scheduled':
        return `
          background: transparent;
          color: ${theme.dashboard.onNavyMuted};
          border: 1px dashed ${theme.colors.borderStrong};
        `
      case 'failed':
        return `
          background: ${theme.dashboard.criticalTint};
          color: ${theme.dashboard.critical};
        `
      case 'neutral':
        return `
          background: ${theme.colors.neutralGray};
          color: ${theme.dashboard.textSubtle};
        `
      default: {
        const exhaustive: never = $tone
        return exhaustive
      }
    }
  }}
`

export const TimelineStem = styled.span`
  flex: 1;
  width: 2px;
  min-height: ${({ theme }) => theme.spacing.md}rem;
  background: ${({ theme }) => theme.colors.borderSoft};
`

export const TimelineBody = styled.div<{ $pad?: 'none' | 'sm' | 'lg' }>`
  flex: 1;
  min-width: 0;
  padding-bottom: ${({ theme, $pad }) =>
    $pad === 'none' ? 0 : $pad === 'lg' ? theme.spacing.xxl : theme.spacing.xl}rem;
  padding-top: ${({ $pad }) => ($pad === 'sm' ? '4px' : '0')};
`
